export default __webpack_public_path__ + "static/media/Layer_15.53fa55d8.svg";